import React from 'react';
import logo from './logo.svg';
import './App.css';

class GetStarted extends React.Component {
  render() {
	  return (
		<div className="App">
			Get Started
		</div>
	  );
  }
}

export default GetStarted;
